export default "__VITE_ASSET__504da203__"